import React from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'
import DailyAttendanceList from '../components/DailyAttendanceList';
import ALLLeaveRequestList from '../components/AllLeaveRequestList';


function AttendanceDashboardPage() {

  return (
    <AppLayout>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-6'>
            <DailyAttendanceList />
          </div>
          <div className='col-md-6'>
            <ALLLeaveRequestList />
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default AttendanceDashboardPage